/**
 * filters the tax return categories list by amount of current notifications
 */

import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "categoryMetaCount",
    standalone: false
})
export class CategoryMetaCountPipe implements PipeTransform {
  transform = (
    value: any[], // list to filter
    args?: string[]
  ): {}[] =>
    // don't filter when list is empty or when 'all' is selected
    !args || args.length < 1 || value.length < 1 || args.indexOf("all") !== -1
      ? value
      : value.filter(v => args.some(a => v && v[this.theSwitch(a)] && v[this.theSwitch(a)] > 0));

  theSwitch = label => {
    switch (label) {
      case "warnings": {
        return "warningCount";
      }
      case "warnings-amended": {
        return "warningAppeaseCount";
      }
      case "comments": {
        return "commentCount";
      }
      case "flags": {
        return "flagCount";
      }
      case "flags-amended": {
        return "flagsAppeaseCount";
      }
      case "notes": {
        return "notesCount";
      }
      case "documents": {
        return "documentCount";
      }
      default: {
        return "";
      }
    }
  };
}
